import { formatTimestampToDate } from "@utilities/dates";
import clsx from "clsx";
import { FunctionComponent } from "react";
import SocialShare from "../C285_SocialShare/C285_SocialShare";
import { Results } from "../CoveoSearchComponent/CoveoSearchComponent";
import styles from "./C225_LatestBlogPosts.module.scss";

interface BlogPostsTemplateProps {
  results: Results[];
  viewMoreLink?: string;
  totalResults?: number;
}

const LatestBlogPostsTemplate: FunctionComponent<BlogPostsTemplateProps> = (
  props
) => {
  const { results, viewMoreLink, totalResults } = props;

  const extractArticleTitle = (text) => {
    return String(text ?? "")
      .replace(/\u00A0/g, " ") // normalize non-breaking spaces
      .trim()
      .split(/\s[–—-]\s/, 1)[0] // split at first " space-dash-space "
      .trim();
  };

  const displayed = Math.min(results.length, 3);

  return (
    <>
      <div className={clsx(styles["CoveoSearchInterface"], styles["wrapper"])}>
        <div className="coveo-result-list-container">
          {results.slice(0, 3).map((result, index) => (
            <div
              key={`${result.ClickUri}-${index}`}
              className={clsx(styles["coveo-list-layout"], "CoveoResult")}
            >
              <div className={styles["blog-post-tile"]}>
                <article>
                  {result.raw.metaimage && (
                    <div className="wrapper-image">
                      <a href={result.ClickUri}>
                        <img
                          data-src=""
                          src={result.raw.metaimage}
                          alt={extractArticleTitle(result.title)}
                        />
                      </a>
                    </div>
                  )}

                  <div className="text">
                    <p className="primary-tag">
                      {formatTimestampToDate(result.raw.metapublishdate)}
                    </p>
                    <h2>
                      <a href={result.ClickUri}>
                        {extractArticleTitle(result.title)}
                      </a>
                    </h2>
                    <p className={styles.copy}>{result.raw.metadescription}</p>

                    <footer>
                      <div
                        className="tag"
                        role="group"
                        aria-label="Article tags"
                      >
                        {result.raw.metatags &&
                          result.raw.metatags.map((tag, index) => (
                            <span key={`${tag}${index}`}>{tag}</span>
                          ))}
                      </div>

                      <SocialShare url={`${result.ClickUri}`} />
                    </footer>
                  </div>
                </article>
              </div>
            </div>
          ))}
        </div>

        <div>{`Results 1-${displayed} of ${totalResults}`}</div>
      </div>

      <div className={styles["latest-blogs-actions"]}>
        <a
          href={viewMoreLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles["external-link"]}
        >
          <i className="icon-external" style={{ backgroundImage: "none" }}>
            <svg
              height="20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
            </svg>
          </i>
          View more
        </a>
      </div>
    </>
  );
};

export default LatestBlogPostsTemplate;
